import { RaygunLoad } from "./raygun-load";

export const getRaygun = () => {
    // eslint-disable-next-line prefer-const
    let _useRaygun = "false"; // Replaced by CI
    if (_useRaygun == "true") {
        return RaygunLoad.load().then((rg4js) => {
            rg4js("apiKey", "oDNJeq7YkYTdhYn4PWCwLA"); // Replaced by CI
            rg4js("setVersion", "a726c3328b7d51189fff1db421bf3ed91c1ac8ee"); // Replaced by CI
            rg4js("enableCrashReporting", true);
            rg4js("disablePulse", true);
            return rg4js;
        });
    }

    return Promise.resolve(null);
};
